import { useTranslation } from '../contexts/TranslationContext';
import { BrandButton } from './ui/BrandButton';
import { landingSectionClassName } from './landingSectionClassName';
import { LandingCoverageGlobe } from './LandingCoverageGlobe';
import { ArrowRight } from './Icons';
import { RegulationSourcesList } from './RegulationSourcesList';

interface LandingCoverageMapProps {
  isVisible: boolean;
  onGetStarted: () => void;
  onStartIntent: () => void;
}

export function LandingCoverageMap({ isVisible, onGetStarted, onStartIntent }: LandingCoverageMapProps) {
  const { t } = useTranslation();
  const globeLabel = t('coverageMap.globeLabel');

  return (
    <section
      id="coverage"
      className={landingSectionClassName({
        tone: 'white',
        className: 'overflow-hidden px-4 py-20 sm:px-6 sm:py-32',
      })}
    >
      <div id="coverage-content" data-animate className={`mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-2 lg:gap-16 transition-all duration-1000 motion-reduce:transition-none ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
        <div className="relative mx-auto w-full lg:order-1">
          <LandingCoverageGlobe isVisible={isVisible} label={globeLabel} />
        </div>

        <div className="text-center lg:order-2 lg:text-left">
          <h2 className="theme-heading-primary mb-5 text-3xl font-normal sm:text-4xl md:text-5xl">
            {t('coverageMap.titlePrefix')}
            <strong className="font-black">{t('coverageMap.titleEmphasis')}</strong>
            {t('coverageMap.titleSuffix')}
          </h2>
          <p className="mx-auto mb-6 max-w-xl text-base leading-relaxed theme-coverage-description sm:text-lg lg:mx-0">{t('coverageMap.description')}</p>
          <RegulationSourcesList className="mb-8" />
          <BrandButton onClick={onGetStarted} onFocus={onStartIntent} onPointerEnter={onStartIntent} onPointerDown={onStartIntent} size="lg" className="group">
            {t('coverageMap.cta')}
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1 motion-reduce:transition-none" />
          </BrandButton>
        </div>
      </div>
    </section>
  );
}
